export enum DATASOURCE_ID {
  BONUS = 2500006,
  PREVIOUS_COMPANIES = 55,
}
